export default __webpack_public_path__ + "static/media/brand.c933ece1.png";